import styled from '@emotion/styled'
import { motion } from 'framer-motion'

import { APP_MAX_WIDTH_PX } from '@/constants'

const TOAST_TOP_PX = 16
const TOAST_SIDE_MARGIN_PX = 16
const TOAST_GAP_PX = 8
const TOAST_PADDING = '12px 14px 12px 16px' // Figma 시안 값 — 우측은 X 버튼 여백 포함이라 14px 비대칭
const TOAST_BORDER_COLOR = '#e4e5e7'
const TOAST_SHADOW = '0px 4px 16px rgba(0, 0, 0, 0.12)'
const TOAST_RADIUS_PX = 16
const TOAST_Z_INDEX = 9999

const CONTENT_GAP_PX = 14
const ICON_SIZE_PX = 48

const LABEL_COLOR = '#ff5626'
const NAME_COLOR = '#1b1c1d'
const PRIZE_COLOR = '#85878e'

const CLOSE_BUTTON_SIZE_PX = 28

export const Container = styled(motion.div)`
  position: fixed;
  top: ${TOAST_TOP_PX}px;
  left: 50%;
  width: calc(100% - ${TOAST_SIDE_MARGIN_PX * 2}px);
  max-width: ${APP_MAX_WIDTH_PX - TOAST_SIDE_MARGIN_PX * 2}px;
  display: flex;
  align-items: center;
  gap: ${TOAST_GAP_PX}px;
  padding: ${TOAST_PADDING};
  background-color: ${({ theme }) => theme.color.white};
  border: 1px solid ${TOAST_BORDER_COLOR};
  border-radius: ${TOAST_RADIUS_PX}px;
  box-shadow: ${TOAST_SHADOW};
  z-index: ${TOAST_Z_INDEX};
`

export const ContentGroup = styled.div`
  display: flex;
  align-items: center;
  gap: ${CONTENT_GAP_PX}px;
  flex: 1;
  min-width: 0;
`

export const ConfettiImage = styled.img`
  width: ${ICON_SIZE_PX}px;
  height: ${ICON_SIZE_PX}px;
  flex-shrink: 0;
  object-fit: contain;
`

export const TextGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
`

export const LabelText = styled.p`
  font-size: 13px;
  font-weight: 600;
  line-height: 18px;
  color: ${LABEL_COLOR};
`

export const NameText = styled.p`
  font-size: 15px;
  font-weight: 700;
  line-height: 20px;
  letter-spacing: -0.075px;
  color: ${NAME_COLOR};
`

export const PrizeText = styled.p`
  font-size: 12px;
  font-weight: 500;
  line-height: 16px;
  letter-spacing: 0.06px;
  color: ${PRIZE_COLOR};
`

export const CloseButton = styled.button`
  width: ${CLOSE_BUTTON_SIZE_PX}px;
  height: ${CLOSE_BUTTON_SIZE_PX}px;
  padding: 0;
  flex-shrink: 0;

  img {
    display: block;
    width: 100%;
    height: 100%;
  }
`
